module.exports = __webpack_public_path__ + "img/bck.bfc51aca.jpg";